import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import styles from './SummerWeatherGraphHeading.module.css'

interface SummerWeatherGraphHeadingProps {
  showWaterTemperature: boolean
  showDaysOfRain: boolean
}

export function SummerWeatherGraphHeading({ showWaterTemperature, showDaysOfRain }: SummerWeatherGraphHeadingProps) {
  const intl = useIntl()

  return (
    <div className={styles.root}>
      <div className={styles.temperatureSection}>
        <Typography variant="body-s-regular-tight">{intl.formatMessage({ id: 'content_weather_heading_max_temperature' })}</Typography>
        <Typography variant="body-s-regular-tight">{intl.formatMessage({ id: 'content_weather_heading_min_temperature' })}</Typography>
      </div>
      {showWaterTemperature && (
        <div className={styles.waterTemperatureHeading}>
          <Typography variant="body-s-regular-tight">{intl.formatMessage({ id: 'content_weather_heading_water_temperature' })}</Typography>
        </div>
      )}
      {showDaysOfRain && (
        <div className={styles.daysOfRainHeading}>
          <Typography variant="body-s-regular-tight">{intl.formatMessage({ id: 'content_weather_heading_days_of_rain' })}</Typography>
        </div>
      )}
    </div>
  )
}
